/**
 * Convert array from flat to nested by using size.
 * ex) [1, 2, 3, 4, 5], 3 -> [[1, 2, 3], [4, 5]]
 * @param {T[]} array
 * @param {number} size
 * @return {T[]}
 */
export function group<T>(array: T[], size: number): T[][] {
  return array.reduce(
    (acc: T[][], cur: T) => (acc[acc.length - 1]?.length ?? 0) < size
      ? [...acc.slice(0, -1), [...acc[acc.length - 1] ?? [], cur]]
      : [...acc, [cur]],
    [],
  );
}

/**
 * Pad on specified sized array end with 'undefined'
 * ex) [1], 3 -> [1, undefined, undefined]
 *
 * @param {T[]} array
 * @param {number} size
 * @param {T} padding
 * @return {(T | undefined)[]}
 */
export function pad<T>(
  array: T[],
  size: number,
  padding?: T,
): (T | undefined)[] {
  return array.concat(Array(size).fill(padding)).slice(0, size);
}
